import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, ComponentPublicInstance } from "vue";
import UserDepartmentForm, {
  Department
} from "../content/UserDepartmentForm.vue";
import UserDepartmentDialog from "./UserDepartmentDialog.vue";
import { Messages } from "@/message";
import { useAlert } from "@/plugins/alert/alert";
import { UserDepartment } from "@/models/user-master/UserMasterRequest";
import { useApi } from "@/plugins/api/api";

type Props = {
  value: boolean;
  userId: number;
};
type Emits = {
  (e: "input", val: boolean): void;
  (e: "submit"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserDepartmentRegist',
  props: {
    value: { type: Boolean },
    userId: null
  },
  emits: ["input", "submit"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  userId: number;
};

const { $post, Paths } = useApi();
const { $alert } = useAlert();




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const form = ref<Department>({ amount1: 0, amount2: 0, amount3: 0 });
const vform = ref<ComponentPublicInstance<typeof UserDepartmentForm>>();

const onSubmit = async () => {
  if (!vform.value?.validate()) {
    $alert("warning", Messages.Form.Validate);
    return;
  }
  const request: UserDepartment = { incode: props.userId, ...form.value };
  const response = await $post(Paths.userMaster.departments.default, request);
  if (response) {
    modelValue.value = false;
    $alert("success", Messages.Success.Regist);
    emits("submit");
  }
};

watch(modelValue, () => {
  form.value = { amount1: 0, amount2: 0, amount3: 0 };
});

return { __sfc: true,$post, Paths, $alert, props, emits, modelValue, form, vform, onSubmit, UserDepartmentForm, UserDepartmentDialog }
}

})